import { FOLDER_TRASH_ID } from "../constants";

const isTrashFolder = (folderId: string) => {
  return folderId === FOLDER_TRASH_ID;
};

export default isTrashFolder;
